import { Heading, Text } from '@ui'
import { APP_NAME } from '../brand.js'

// Public (no sign-in): the app's Settings links here. Minimal for now (decided 2026-10-03).
export default function Terms() {
  return (
    <article className="legal">
      <Heading size={3}>Terms</Heading>
      <Text as="p" muted>Last updated 3 October 2026.</Text>
      <ul>
        <li>{APP_NAME} (the app and this website) is a personal project, provided as is, with no warranty.</li>
        <li>
          Don't rely on it for navigation or safety. Distances, heights, maps and weather can be wrong
          or out of date, and weather warnings can be late or missing. Check official sources and
          plan for the conditions.
        </li>
        <li>Map and weather data belong to their providers (see Credits) and are used under their terms.</li>
        <li>The website is private: use it only if you have been invited.</li>
        <li>These terms may change; this page always shows the current version.</li>
      </ul>
    </article>
  )
}
